// CSS from https://github.com/vineethtrv/css-loader

export const Loader = () => {
  return (
    <div
      data-testid='custom-loader'
      className='flex justify-center items-center h-screen w-full bg-sys-color-surface-background-default'
    >
      <div
        className={`w-12 h-12 rounded-gl-border-radius-pill relative animate-rotate`}
      >
        <div className='box-border absolute inset-0 rounded-gl-border-radius-pill border-[5px] border-sys-color-content-primary animate-prixClipFix' />
        <div
          className='box-border absolute inset-0 rounded-gl-border-radius-pill border-[5px] border-sys-color-content-active animate-prixClipFix'
          style={{ transform: 'rotate3d(90, 90, 0, 180deg)' }}
        />
      </div>
    </div>
  )
}
